import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledBox = styled.div`
  overflow: hidden;
  white-space: nowrap;
`;
